import { render, staticRenderFns } from "./WeeklyScheduling.vue?vue&type=template&id=5afba463&"
import script from "./WeeklyScheduling.vue?vue&type=script&lang=js&"
export * from "./WeeklyScheduling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports